"use client";

import Link from "next/link";

import { css, cva } from "../../../styled-system/css";
import Button from "../ui/Button";

const contactContainerRecipe = cva({
  base: {
    backgroundColor: "white",
    padding: "8",
    textAlign: "center",
    sm: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "8",
    },
  },
});

function ContactSection() {
  return (
    <div
      className={css({
        width: "100%",
      })}
    >
      <div className={contactContainerRecipe()}>
        <div
          className={css({
            textAlign: "center",
            mb: "4",
            sm: { textAlign: "left", mb: "0" },
          })}
        >
          <div className={css({ mb: "2" })}>
            <span
              className={css({
                fontSize: "xl",
                fontWeight: "semibold",
                color: "gray.900",
              })}
            >
              Still have questions?
            </span>
          </div>
          <div>
            <span className={css({ color: "slate.600" })}>
              {`Can't find the answer you're looking for? Please chat to our
                friendly team.`}
            </span>
          </div>
        </div>
        <div className={css({ sm: { height: "fit", flexShrink: "0" } })}>
          <Button variant="brandBlue" width="fit" asChild>
            <Link href="/faqs#contact-us" prefetch>
              Get In Touch
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ContactSection;
